//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from "store/constants";
import { filter } from "lodash";
import { cloneDeep } from "lodash";

//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

//  -- Example ------------------------

const cognatesInit = [];

export const vocabulary_cogantes = (state = cognatesInit, action) => {
  switch (action.type) {
    case ActionTypes.vocabularyCogantes.listVocabularySuccessCogantes:
      return action.payload;

    case ActionTypes.vocabularyCogantes.listVocabularyFailCogantes:
      return state;

    case ActionTypes.vocabularyCogantes.createVocabularyCogantes:
      if (action.payload) {
        return [...state, action.payload];
      } else {
        return [...state];
      }

    case ActionTypes.vocabularyCogantes.createVocabularyCogantesAI:
      return [...state, ...action.payload];
    case ActionTypes.vocabularyCogantes.updateVocabularySuccessCogantes:
      return state.map((x) => {
        if (x.id === action.payload?.id) {
          return { ...x, ...action.payload };
        }
        return x;
      });

    case ActionTypes.vocabularyCogantes.deleteVocabularySuccessCogantes:
      const delv = cloneDeep(state);
      const result = filter(delv, (k) => k.id != action.payload.id);
      return result;

    default:
      return state;
  }
};
